<div id="main" class="main">
    <div class ="wave">
        <div class="svg" *ngIf="wabeExist; else noWaveTemplate">
            <img class="svg-wabe" [src]="wabeExist" alt="logo"> 
        </div>
        <ng-template #noWaveTemplate>
        </ng-template>
    </div>
    <div>
        <app-header class="section-header"></app-header>
    </div>
</div>

<section class="iconos-footer">
    <div *ngIf="mostrarPCI()" class="btn-float-certidied">
        <img width="100px" height="67px" src="assets/img/pci-logo.webp" alt="certified" class="img-fluid">
    </div>
    
    <div class="btn-float"  (click)="sendMessage()">
        <div style="justify-content: center;
        align-items: center; display: flex">
            <div class="flex section1 flex-column col-9">
                <div class="col-12 p-0">
                    <span>¿Necesitas Ayuda?</span>
                </div>
                <div class="col-12 p-0">
                    <span class="font-title-light">Contacta con un asesor</span>
                </div>
            </div>
            <div>
                <i style="color: #2CD46B" class='icon-float bx bxl-whatsapp'></i>
            </div>
        </div>
    </div>
</section>




